import React from "react";
import styles from "./settings.module.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Settings from "components/Setting/Settings";
import Admin from "components/Setting/Admin";
import ContainerHeader from "common/ContainerHeader";
import Analytics from "components/Setting/Analytics";

const Setting = () => {
  return (
    <>
      <ContainerHeader label="Settings" showAddButton={false} />
      <div className={styles.container}>
        <Tabs>
          <TabList>
            <Tab style={{ width: "79px" }}>Settings</Tab>
            <Tab style={{ width: "79px" }}>Admins</Tab>
            {/* <Tab>Analytics</Tab> */}
          </TabList>
          <TabPanel>
            <div className={styles.narrowFormContainer} style={{ width: '70rem' }}>
              <Settings />
            </div>
          </TabPanel>

          <TabPanel>
            <div className={styles.formContainer}>
              <Admin />
            </div>
          </TabPanel>

          {/* <TabPanel>
            <Analytics />
          </TabPanel> */}
        </Tabs>
      </div>
    </>
  );
};

export default Setting;
